function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "url(#paint0_linear_pax)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.89121 4.66159C6.07285 4.45459 6.23839 4.27792 6.39653 4.12999C3.72367 4.04325 4.50171 5.99032 3.63073 7.96904C2.62775 10.2479 3.74875 11.1163 5.41915 11.3869C5.18762 11.1115 4.99858 10.7965 4.8547 10.4565C3.77172 9.08252 4.2076 6.57938 5.89121 4.66159Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3226 7.08911C12.0739 7.79498 11.6174 8.58706 10.9722 9.36662C10.4692 9.97405 9.91006 10.4524 9.33293 10.7989C8.66577 11.2344 7.83809 11.4914 6.91273 11.4914C6.39474 11.4914 5.88546 11.4624 5.41895 11.3869C5.69457 11.7144 6.02961 11.9863 6.41929 12.176C8.8358 13.3536 8.98839 11.166 11.5451 10.056C12.9808 9.43261 12.9861 8.21403 12.3226 7.08911Z",
  fill: "#ECF1F3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.3323 4.81251C9.68872 4.87797 10.0269 4.9961 10.3297 5.16851C11.1413 5.63119 11.8806 6.33919 12.3228 7.08896C12.7581 5.85336 12.5554 4.88196 11.6028 4.70609C10.556 4.51319 9.73756 4.4512 8.95107 3.89778C7.98241 3.21613 7.13334 3.44095 6.39648 4.13006C6.44849 4.13165 6.50156 4.13405 6.55621 4.13724C7.57847 4.1979 8.55399 4.39852 9.3323 4.81251Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.89126 4.66148C4.20765 6.57927 3.77177 9.08241 4.85475 10.4564C4.36844 9.30617 4.40223 7.87155 5.08761 6.72614C6.00003 5.20106 7.83017 4.53616 9.3324 4.8126C8.55409 4.39834 7.57856 4.198 6.55657 4.13707C6.50166 4.13387 6.44859 4.13175 6.39658 4.12988C6.23844 4.27781 6.0729 4.45448 5.89126 4.66148Z",
  fill: "#ECF1F3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3295 5.16874C10.0266 4.99606 9.68845 4.8782 9.33203 4.81274C10.3569 5.35791 11.0389 6.27397 11.0312 7.73307C11.0244 8.99901 10.3754 10.1178 9.33282 10.7989C9.90996 10.4525 10.4694 9.97413 10.9721 9.36671C11.6176 8.58714 12.0738 7.79506 12.3225 7.08919C11.8803 6.33942 11.141 5.63116 10.3295 5.16874Z",
  fill: "#9FAFB9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.16409 10.1051C8.00692 10.8543 6.46404 10.5201 5.71767 9.35851C4.97131 8.19687 5.3404 6.70105 6.46113 5.89807C7.7144 5.00037 9.32171 5.3545 9.90755 6.64465C10.4789 7.9026 10.321 9.35585 9.16409 10.1051ZM9.33279 4.81253C7.83056 4.53635 6.00043 5.20098 5.088 6.72606C4.40263 7.87147 4.36857 9.30636 4.85514 10.4563C4.99903 10.7963 5.1878 11.1116 5.4196 11.387C5.88611 11.4625 6.39539 11.4913 6.91312 11.4913C7.83875 11.4913 8.66643 11.2343 9.33332 10.7987C10.3762 10.1179 11.0251 8.99879 11.0317 7.73285C11.0396 6.27375 10.3574 5.35769 9.33279 4.81253Z",
  fill: "#D8E0E3"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_pax",
  x1: 8,
  y1: 0,
  x2: 8,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00845D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00845D"
})));

var SvgPax = function SvgPax(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pax.234a17cc.svg";
export { ForwardRef as ReactComponent };